import { atom } from "recoil";

import {
  IPreGlobalSearchCalendarSnapshot,
  ITranslatableItem,
} from "../../models";

export const globalSearchAtom = atom<string>({
  key: "globalSearchAtom",
  default: "",
});

export const globalSearchErrorsAtom = atom<ITranslatableItem[] | undefined>({
  key: "globalSearchErrorsAtom",
  default: undefined,
});

/** Calendar dates/mode before global ride-id search overrode them (restored on clear). */
export const preGlobalSearchCalendarAtom = atom<
  IPreGlobalSearchCalendarSnapshot | undefined
>({
  key: "preGlobalSearchCalendarAtom",
  default: undefined,
});
